import gql from 'graphql-tag'

export const CHECK_ALL_MOVIES_WATCHED_QUERY = gql`
  query checkAllMoviesWatchedQuery {
   CheckAllMoviesWatched
  } 
`



// WEBPACK FOOTER //
// ./src/queries/CHECK_ALL_MOVIES_WATCHED_QUERY.ts